export const GET_IMPORT_SUMMARY = "GET_IMPORT_SUMMARY";
export const START_LOADING_IMPORT_SUMMARY = "START_LOADING_IMPORT_SUMMARY";
export const ERROR_LOADING_IMPORT_SUMMARY = "ERROR_LOADING_IMPORT_SUMMARY";
export const STOP_LOADING_IMPORT_SUMMARY = "STOP_LOADING_IMPORT_SUMMARY";
